<template>
  <div v-if='route'>
    <v-card-text>
      <span v-if='isLead(route)'>
        You are the <strong class='primary--text'>lead</strong> on a route.
      </span>
      <span v-else>You are the copilot on a route.</span>
      <ul>
        <li v-if='isLead(route)'>
          {{ route.copilot ? "Your co-pilot:" : "You're solo today" }}
          <strong class='info--text' v-if='route.copilot_obj !== null && route.copilot_obj !== undefined'>{{ route.copilot_obj.name_display }}</strong>
        </li>
        <li v-else>
          The route lead is:
          <strong class='primary--text'>{{ route.lead_obj.name_display }}</strong>
        </li>
        <li v-if='route.vehicle'>
          Your vehicle:
          <strong class='info--text'>{{ route.vehicle_obj.name }}</strong>
        </li>
        <li v-if='projectsThatNeedKeys.length > 0'>
          You need to bring <strong class='primary--text'>keys</strong> for:
          <ul style="list-style-type:square;">
            <template v-for='(project, index) in projectsThatNeedKeys'>
              <li :key='index' class='error--text ml-2 font-weight-bold'>{{ project.project_name }}</li>
            </template>
          </ul>
        </li>
        <li v-if='appointments.length > 0'>
          You have <strong class='primary--text'>{{ appointments.length === 1 ? ' an appointment ' : ' appointments ' }}</strong> at:
          <ul style="list-style-type:square;">
            <template v-for='(appointment, index) in appointments'>
              <li
                :key='index * 1000'
                class='error--text ml-2 font-weight-bold'
              >
                <span>{{ appointment.apt_time | time }}</span>
                <span v-if='appointment.apt_end'> - {{ appointment.apt_end | time }} window</span>
              </li>
            </template>
          </ul>
        </li>
        <li v-if='!!route.notes'>
          Note from the office:
          <div class='ml-4 primary--text font-weight-bold'>{{ route.notes}}</div>
        </li>
      </ul>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color='primary'
        depressed
        small
        @click='openRoute'
      >
        Open route
        <v-icon right>mdi-arrow-up</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import _ from 'lodash'
import scheduleAPI from '@/modules/schedule/api/schedule'

export default {
  name: 'route-details',
  props: {
    routeID: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    route: { lead_obj: {} }
  }),
  computed: {
    projectsThatNeedKeys () {
      // this was written before this field was placed on the wo, and may need an update later depending on backend implementation.
      return _.filter(this.route.wos, w => w.project_needs_key)
    },
    appointments () {
      return _.filter(this.route.wos, w => !!w.apt_time)
    },
  },
  mounted () {
    this.getFullRoute()
  },
  methods: {
    openRoute () {
      this.$router.push({ name: 'FieldRoute', params: { id: this.route.id } })
    },
    isLead (route) {
      return route.lead_obj.id === this.$store.state.auth.profile.id
    },
    async getFullRoute () {
      this.isLoading = true
      this.route = await scheduleAPI.getRoute(this.routeID)
      this.isLoading = false
    },
  }
}
</script>
